module.exports = __webpack_public_path__ + "img/logo1.6c9b0614.png";